// Structural/numeric service catalog data -- slug, coach, duration, price, deposit, and a
// representative photo. Name/description text still routes through home.services.items.<slug>
// in the i18n dictionary (see en.ts's comment on why). Shared between the homepage teaser and
// the dedicated /services page so the two never drift apart. Mirrors
// functions/src/scripts/seed.ts's `services` array -- keep slugs, prices, and depositPercent in
// sync with it.
export interface ServiceListing {
  slug: string;
  coach: string;
  duration: string;
  priceInr: number;
  // Percent of priceInr due today to hold the slot -- 100 for Trial (paid in full, no deposit
  // split, see seed.ts). Used to show the real "book for ₹X" amount on the CTA rather than the
  // full price, since that's what's actually charged at booking time.
  depositPercent: number;
  image: string;
  imageAlt: string;
  // CSS object-position for the card thumbnail -- these are real source photos, not stock crops,
  // so a plain center crop sometimes cuts Devina's face out of the very short/wide card frame.
  // Each value below was picked by actually rendering the crop at the card's real aspect ratio
  // and checking the result, not guessed. "center" is the default and needs no override.
  imagePosition: string;
}

export const SERVICES: ServiceListing[] = [
  {
    slug: "hooping",
    coach: "Devina",
    duration: "60 min",
    priceInr: 2000,
    depositPercent: 30,
    image: "/images/gallery-4.jpg",
    imageAlt: "Devina performing a fire hoop routine",
    imagePosition: "50% 30%",
  },
  {
    slug: "hula-hoop",
    coach: "Devina",
    duration: "45 min",
    priceInr: 1500,
    depositPercent: 30,
    image: "/images/hero-hoop-rocks.jpg",
    imageAlt: "Devina hooping outdoors on a rocky hilltop",
    imagePosition: "50% 65%",
  },
  {
    slug: "yoga",
    coach: "Devina",
    duration: "60 min",
    priceInr: 1500,
    depositPercent: 30,
    image: "/images/devina/photo-26.jpg",
    imageAlt: "Devina in a standing yoga pose in a park",
    imagePosition: "center",
  },
  {
    slug: "pregnancy-yoga",
    coach: "Devina",
    duration: "60 min",
    priceInr: 1500,
    depositPercent: 30,
    image: "/images/gallery-2.jpg",
    imageAlt: "Devina in a calm, seated pose",
    imagePosition: "center",
  },
  {
    slug: "trial",
    coach: "Devina",
    duration: "30-60 min",
    priceInr: 2000,
    depositPercent: 100,
    image: "/images/gallery-5.jpg",
    imageAlt: "Devina performing an LED hoop routine",
    imagePosition: "center",
  },
  {
    slug: "nutrition-plan",
    coach: "Devina",
    duration: "45 min",
    priceInr: 1500,
    depositPercent: 30,
    image: "/images/devina/photo-38.jpg",
    imageAlt: "Devina smiling in a garden",
    imagePosition: "50% 20%",
  },
];
